// import { MddCurrency, MddDecimal } from '@macrocura/utils';
import { Descriptions } from 'antd';
import * as React from 'react';
import { CATEGORY_ORIGINAL } from 'src/constants/Order';
import { IOrderInfo } from 'src/entity/OrderEntity';
import DrugStoreService from 'src/services/DrugStoreService';
import I18N from 'src/services/I18NService';
import OrderService from 'src/services/OrderService';
import { UtilDateTime } from 'src/utils/datetime';

interface IOrderInfoProps {
  /** 订单明细 */
  orderInfo: IOrderInfo;
  /**
   * 订单是否参与分账:
   * 参与--新流程(通联)(不含记账支付):
   *   应收金额取 user_receivable_profit_amount字段
   *   实收金额取 user_received_profit_amount字段
   * 不参--记账支付与旧流程:
   *   应收金额取 transfer_amount_after_tax字段
   *   不显示分账信息
   * 注:
   * 1, 根据platform_name是否有值判断 新旧流程
   * 2, 若新流程中 user_receivable_profit_amount,
   * user_received_profit_amount字段为null，
   * 代表此合作商不参与分账，不显示分账信息;
   */
  isSubAccount: boolean;
}

class OrderInfo extends React.Component<IOrderInfoProps> {
  /** 支付方式 */
  formatUseMedicalInsurance(type: boolean | null): string {
    if (typeof type === 'boolean') {
      if (type) {
        return '医保';
      } else {
        return '自费';
      }
    } else {
      return '';
    }
  }
  render() {
    // const { orderInfo, isSubAccount } = this.props;
    const { orderInfo } = this.props;
    // const currencySymbol = MddCurrency.getCurrencySymbol(orderInfo.currency);
    // 应收金额
    // let receivableAmount = orderInfo.transfer_amount_after_tax;
    // const { user_profit_amount: profitAmount } = orderInfo;
    // if (isSubAccount && profitAmount) {
    //   // 参与分账则取user_receivable_profit_amount字段(后台单位分)
    //   if (typeof profitAmount.user_receivable_profit_amount === 'number') {
    //     receivableAmount = MddDecimal.decimalCeil(profitAmount.user_receivable_profit_amount / 100).toFixed(2);
    //   } else {
    //     receivableAmount = (0).toFixed(2);
    //   }
    // }
    // 支付方式描述
    const paymentTypeDesc = OrderService.getPaymentDescByValue(orderInfo.payment_type);
    const payMethod = this.formatUseMedicalInsurance(orderInfo.is_use_medical_insurance)
    return (
      <div className="div-row">
        <div className="div-col-3 text-align-right">{I18N.get('common_basic_info')}</div>
        <div className="div-col-15 order_info">
          <Descriptions title="" bordered={false}>
            <Descriptions.Item label={I18N.get('order_no')}>{orderInfo.out_trade_no}</Descriptions.Item>
            <Descriptions.Item label={I18N.get('order_status')}>{OrderService.getPayStatusDesc(orderInfo.pay_status)}</Descriptions.Item>
            <Descriptions.Item label={I18N.get('common_create_date')}>{UtilDateTime.getDateTimeFormat(orderInfo.created_time)}</Descriptions.Item>
            <Descriptions.Item label={I18N.get('nav_drugStore')}>{DrugStoreService.getDrugStoreNameById(orderInfo.store)}</Descriptions.Item>
            <Descriptions.Item label={I18N.get('common_institution_name')}>{orderInfo.institution_name}</Descriptions.Item>
            {orderInfo.category !== CATEGORY_ORIGINAL && (<Descriptions.Item label="支付方式">{payMethod}</Descriptions.Item>)}
            {/* <Descriptions.Item label={I18N.get('order_real_total_amount')}>
              {currencySymbol}
              {orderInfo.order_payment_amount}
            </Descriptions.Item> */}
            {/* <Descriptions.Item label={I18N.get('order_receivable_amount')}>
              {currencySymbol}
              {receivableAmount}
            </Descriptions.Item> */}
            <Descriptions.Item label={I18N.get('order_payment')}>{paymentTypeDesc}</Descriptions.Item>
            <Descriptions.Item label={I18N.get('order_pay_no')}>{orderInfo.platform_trade_no}</Descriptions.Item>
          </Descriptions>
        </div>
      </div>
    );
  }
}

export default OrderInfo;



// WEBPACK FOOTER //
// ./src/components/views/Order/components/OrderInfo.tsx